window.validateFile = function() {
  const fileInput = document.getElementById('background_image_input');
  const fileError = document.getElementById('file-error');
  const uploadBtn = document.getElementById('upload-btn');
  const previewSection = document.getElementById('preview-section');
  const previewImage = document.getElementById('preview-image');
  const fileNameDisplay = document.getElementById('file-name-display');

  if (!fileInput || !fileError || !uploadBtn || !previewSection || !previewImage || !fileNameDisplay) {
    return;
  }
  
  if (fileInput.files && fileInput.files.length > 0) {
    const file = fileInput.files[0];
    
    // Validate file type
    if (!file.type.startsWith('image/')) {
      fileError.textContent = '※画像ファイルを選択してください';
      fileError.classList.remove('d-none');
      uploadBtn.disabled = true;
      uploadBtn.style.opacity = '0.5';
      previewSection.classList.add('d-none');
      return;
    }
    
    // Show file name
    fileNameDisplay.textContent = file.name;
    
    // Show preview
    const reader = new FileReader();
    reader.onload = function(e) {
      previewImage.src = e.target.result;
      previewSection.classList.remove('d-none');
    };
    reader.readAsDataURL(file);
    
    fileError.classList.add('d-none');
    uploadBtn.disabled = false;
    uploadBtn.style.opacity = '1';
  } else {
    // Only show error if there's no existing image
    if (!previewSection || previewSection.classList.contains('d-none')) {
      fileError.classList.remove('d-none');
      uploadBtn.disabled = true;
      uploadBtn.style.opacity = '0.5';
      fileNameDisplay.textContent = '※画像を選択してください';
    }
    previewSection.classList.add('d-none');
  }
}

// Initialize button state and form validation
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form');
  const uploadBtn = document.getElementById('upload-btn');
  const previewSection = document.getElementById('preview-section');

  if (!form || !uploadBtn || !previewSection) {
    return;
  }
  
  // Set initial button state
  if (previewSection && !previewSection.classList.contains('d-none')) {
    // Has existing image
    uploadBtn.disabled = false;
    uploadBtn.style.opacity = '1';
  } else {
    // No existing image
    uploadBtn.disabled = true;
    uploadBtn.style.opacity = '0.5';
  }
  
  form.addEventListener('submit', function(e) {
    const fileInput = document.getElementById('background_image_input');
    const fileError = document.getElementById('file-error');
    
    // Hide error message first
    fileError.classList.add('d-none');
    
    // Only show error if no file is selected AND no existing image
    if (!fileInput.files || fileInput.files.length === 0) {
      if (!previewSection || previewSection.classList.contains('d-none')) {
        e.preventDefault();
        fileError.classList.remove('d-none');
        return false;
      }
    }
  });
});
